module.exports = __webpack_public_path__ + "img/speaker-MaryPilon-imgs.5bfea278.png";